import { render } from "./ChapterAdd.vue?vue&type=template&id=46d4f957"
import script from "./ChapterAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/chapter/ChapterAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46d4f957"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46d4f957', __exports__)) {
    api.reload('46d4f957', __exports__)
  }
  
  module.hot.accept("./ChapterAdd.vue?vue&type=template&id=46d4f957", () => {
    api.rerender('46d4f957', render)
  })

}


export default __exports__